import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import CONSTANTS from "../routes/common.json";
import { loginUser } from "../actions/authActions";
import Input from "../components/reuseables/input-fields/Input";
import isEmpty from "../utils/isEmpty";
import { mustContainsOneLowercaseAlphabet, mustContainsOneNumericCharacter, mustContainsOneUppercaseAlphabet } from "../utils/inputValidation";

const { REGISTER, FORGOT_PASSWORD } = CONSTANTS.ROUTES;

const IncomingSignIn = (props) => {
  const { dispatch, networkResponse, isLoading, errors } = props;
  const [userInput, setUserInput] = useState({ email: "", password: "" });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [pwdError, setPwdError] = useState("");
  const handleChange = (e) => {
    setUserInput({ ...userInput, [e.target.name]: e.target.value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (userInput.password.length <8) {
      setPwdError("The password must be at least 8 characters.");
      setTimeout(() => setPwdError(false), 3000);
      return;
    }
   
    if (!mustContainsOneLowercaseAlphabet.test(userInput.password)) {
      setPwdError("must contains at least one lowercase character");
      setTimeout(() => setPwdError(""), 3000);
      return;
    } else if (!mustContainsOneUppercaseAlphabet.test(userInput.password)) {
      setPwdError("must contains at least one uppercase character");
      setTimeout(() => setPwdError(false), 3000);
      return;

    } else if (!mustContainsOneNumericCharacter.test(userInput.password)) {
      setPwdError("must contains at least one numeric character");
      setTimeout(() => setPwdError(""), 3000);
      return;
    }

    dispatch(loginUser(userInput));
    setUserInput({ ...userInput, password: "" });
  };
  if (networkResponse?.redirectTo) {
    return <Redirect to={networkResponse.redirectTo} />;
  }

  const viewPassword=()=>{
setPasswordVisible(state => !state)
  }

  return (
  <div className="form-container p-3 m-auto">
    <div className="logo-container-sm mb-2">
        <svg className="mb-3" width="91" height="37" viewBox="0 0 91 37" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="89" height="35" rx="15" fill="white" stroke="#0D894D"
            strokeWidth="2" />
        <path
            d="M24.15 22.425C24.15 23.175 24 23.8333 23.7 24.4C23.4 24.9667 22.9833 25.4417 22.45 25.825C21.9333 26.2083 21.325 26.5 20.625 26.7C19.9417 26.9 19.2083 27 18.425 27H9.85V9.25H19.35C19.9667 9.25 20.525 9.38333 21.025 9.65C21.525 9.91667 21.95 10.2667 22.3 10.7C22.65 11.1167 22.9167 11.6 23.1 12.15C23.3 12.6833 23.4 13.225 23.4 13.775C23.4 14.6417 23.1833 15.4583 22.75 16.225C22.3167 16.975 21.6833 17.5333 20.85 17.9C21.8667 18.2 22.6667 18.7417 23.25 19.525C23.85 20.2917 24.15 21.2583 24.15 22.425ZM20.675 21.775C20.675 21.4583 20.6167 21.1583 20.5 20.875C20.4 20.575 20.2583 20.3167 20.075 20.1C19.8917 19.8833 19.675 19.7167 19.425 19.6C19.175 19.4667 18.9 19.4 18.6 19.4H13.3V24.075H18.425C18.7417 24.075 19.0333 24.0167 19.3 23.9C19.5833 23.7833 19.825 23.625 20.025 23.425C20.225 23.2083 20.3833 22.9583 20.5 22.675C20.6167 22.3917 20.675 22.0917 20.675 21.775ZM13.3 12.2V16.675H17.9C18.4833 16.675 18.975 16.475 19.375 16.075C19.7917 15.675 20 15.125 20 14.425C20 13.7417 19.8083 13.2 19.425 12.8C19.0583 12.4 18.6 12.2 18.05 12.2H13.3ZM41.3172 27V15.25L36.7422 24H34.8672L30.2922 15.25V27H26.8422V9.25H30.5422L35.7922 19.35L41.0922 9.25H44.7672V27H41.3172ZM53.523 9.25H56.573L63.323 27H59.773L58.123 22.575H51.923L50.298 27H46.748L53.523 9.25ZM57.498 20.15L55.048 13.175L52.498 20.15H57.498ZM63.5357 18C63.5357 16.9167 63.7274 15.85 64.1107 14.8C64.5107 13.7333 65.0857 12.7833 65.8357 11.95C66.5857 11.1167 67.5024 10.4417 68.5857 9.925C69.6691 9.40833 70.9024 9.15 72.2857 9.15C73.9191 9.15 75.3274 9.50833 76.5107 10.225C77.7107 10.9417 78.6024 11.875 79.1857 13.025L76.5357 14.85C76.3024 14.35 76.0191 13.9333 75.6857 13.6C75.3524 13.25 74.9941 12.975 74.6107 12.775C74.2274 12.575 73.8274 12.4333 73.4107 12.35C72.9941 12.25 72.5857 12.2 72.1857 12.2C71.3191 12.2 70.5607 12.375 69.9107 12.725C69.2774 13.075 68.7441 13.5333 68.3107 14.1C67.8941 14.65 67.5774 15.2833 67.3607 16C67.1441 16.7 67.0357 17.4 67.0357 18.1C67.0357 18.8833 67.1607 19.6417 67.4107 20.375C67.6607 21.0917 68.0107 21.725 68.4607 22.275C68.9274 22.825 69.4774 23.2667 70.1107 23.6C70.7607 23.9333 71.4691 24.1 72.2357 24.1C72.6357 24.1 73.0524 24.05 73.4857 23.95C73.9191 23.85 74.3274 23.6917 74.7107 23.475C75.1107 23.2583 75.4774 22.9833 75.8107 22.65C76.1441 22.3 76.4107 21.8833 76.6107 21.4L79.4357 23.025C79.1524 23.6917 78.7441 24.2833 78.2107 24.8C77.6941 25.3 77.1024 25.725 76.4357 26.075C75.7857 26.425 75.0857 26.6917 74.3357 26.875C73.5857 27.0583 72.8524 27.15 72.1357 27.15C70.8691 27.15 69.7107 26.8833 68.6607 26.35C67.6107 25.8167 66.7024 25.125 65.9357 24.275C65.1857 23.4083 64.5941 22.4333 64.1607 21.35C63.7441 20.25 63.5357 19.1333 63.5357 18Z"
            fill="#0D894D" />
        </svg>
    </div>
    <h3 className="text-center">Sign In</h3>
    <form onSubmit={handleSubmit}>
      <Input
        required
        label="Email"
        type="email"
        name="email"
        onChange={handleChange}
        value={userInput.email}
        errorMessage={isEmpty(errors) ? null : errors?.data?.errors?.email}
      />
      <div className="position-relative">     
      <Input
        required
        label="Password"
        type={`${passwordVisible? "text":"password"}`}
        name="password"
        onChange={handleChange}
        value={userInput.password}
        errorMessage={isEmpty(errors) ? null : errors?.data?.errors?.password}
      />
      <i className={`position-absolute fa ${passwordVisible? "fa-eye-slash":"fa-eye"}`} aria-hidden="true" style={{
        right:"14px",
        top:"53%",
        cursor:"pointer"
      }}
      onClick={viewPassword}></i>
      </div>
      <span className="error text">{pwdError === "" ? null : pwdError}</span>

        <div className="form-group mt-3">
            <button disabled={isLoading.loading} className="btn btn-register">{isLoading.loading ? "Sending..." : "Sign in" }</button>
        </div>
        <p className="sign mt-2 text-muted">Don't have an account? <Link to={REGISTER}>Sign up</Link></p>
        <p className="sign mt-2 text-muted">Forgot Password? <Link to={FORGOT_PASSWORD}>Reset password</Link></p>
    </form>
</div>
  );
};

const mapStateToProps = (state) => {
  const { isLoading, errors, networkResponse } = state;
  return {
    isLoading,
    errors,
    networkResponse,
  };
};

export default connect(mapStateToProps)(IncomingSignIn);
